import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconHighlightDirective } from './icon-highlight.directive';

@NgModule({
  declarations: [
    IconHighlightDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IconHighlightDirective
  ]
})
export class IconHighlightModule { }
